<link href="https://fonts.googleapis.com/icon?family=Material+Icons" rel="stylesheet">

<router-outlet>

</router-outlet>